module.exports = __webpack_public_path__ + "static/media/Madfit_Website_09.f99e8c61.jpg";